import { UntitledIcon } from '@faceup/icons'
import { ulInfoCircle } from '@faceup/icons/ulInfoCircle'
import { Typography } from '@faceup/ui-base'
import { type FragmentType, getFragmentData, graphql } from '../../../../__generated__'
import { SentContent } from '../../../../Components/SentContent/SentContent'
import { useReportSentData } from '../../hooks'
import { PinForm } from './components'

export const fragments = {
  ReportSentGeneral_publicReportSource: graphql(`
    fragment ReportSentGeneral_publicReportSource on PublicReportSource {
      id
      sourceType

      ...useReportSentData_publicReportSource
      ...PinForm_publicReportSource
    }
  `),
}

type ReportSentGeneralProps = {
  reportSource: FragmentType<typeof fragments.ReportSentGeneral_publicReportSource>
}

export const ReportSentGeneral = ({ reportSource: _reportSource }: ReportSentGeneralProps) => {
  const reportSource = getFragmentData(
    fragments.ReportSentGeneral_publicReportSource,
    _reportSource
  )
  const { reportSentDescription } = useReportSentData(reportSource)

  return (
    <SentContent sourceType={reportSource.sourceType}>
      <PinForm reportSource={reportSource} />
      <div className='flex gap-2'>
        <div>
          <UntitledIcon icon={ulInfoCircle} />
        </div>
        <Typography.Paragraph>{reportSentDescription}</Typography.Paragraph>
      </div>
    </SentContent>
  )
}
